import { createSlice } from "@reduxjs/toolkit";

export const contractBetSlice = createSlice({
    name: "contractBet",
    initialState: {
        value: 0,
        bets: {
            back: {},
            lay: {}
        }
    },
    reducers: {
        addContract: (state, action) => {
            var polarityKey = action.payload.isBack ? "back" : "lay";

            state.bets[polarityKey][action.payload.selection.selectionId] = {
                selection: action.payload.selection, offer: action.payload.offer
            };
        },
        removeContract: (state, action) => {
            var polarityKey = action.payload.isBack ? "back" : "lay";
            delete state.bets[polarityKey][action.payload.selection.selectionId];
        },
        toggleContract: (state, action) => {
            var polarityKey = action.payload.isBack ? "back" : "lay";

            if (state.bets[polarityKey][action.payload.selection.selectionId]) {
                delete state.bets[polarityKey][action.payload.selection.selectionId];
            } else {
                state.bets[polarityKey][action.payload.selection.selectionId] = {
                    selection: action.payload.selection, offer: action.payload.offer
                };
            }

        }
    }
});

// Action creators are generated fo r each case reducer function
export const { toggleContract, addContract, removeContract } = contractBetSlice.actions;

export default contractBetSlice.reducer;